var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrequencyWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5261_10731)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 11.16V12.85C19 13.29 18.64 13.65 18.2 13.65C17.76 13.65 17.4 13.29 17.4 12.85V11.16C17.4 10.72 17.76 10.36 18.2 10.36C18.64 10.36 19 10.72 19 11.16ZM8.93 7.68C9.37 7.68 9.73 8.04 9.73 8.48V15.52C9.73 15.96 9.37 16.32 8.93 16.32C8.49 16.32 8.13 15.96 8.13 15.52V8.48C8.13 8.04 8.49 7.68 8.93 7.68ZM5.8 10.36C6.24 10.36 6.6 10.72 6.6 11.16V12.85C6.6 13.29 6.24 13.65 5.8 13.65C5.36 13.65 5 13.29 5 12.85V11.16C5 10.72 5.36 10.36 5.8 10.36ZM15.13 7.68C15.57 7.68 15.93 8.04 15.93 8.48V15.52C15.93 15.96 15.57 16.32 15.13 16.32C14.69 16.32 14.33 15.96 14.33 15.52V8.48C14.33 8.04 14.69 7.68 15.13 7.68ZM12 5C12.44 5 12.8 5.36 12.8 5.8V18.2C12.8 18.64 12.44 19 12 19C11.56 19 11.2 18.64 11.2 18.2V5.8C11.2 5.36 11.56 5 12 5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 1.64C17.71 1.64 22.36 6.29 22.36 12C22.36 17.71 17.71 22.36 12 22.36C6.29 22.36 1.64 17.71 1.64 12C1.64 6.29 6.29 1.64 12 1.64ZM12 0C5.37 0 0 5.37 0 12C0 18.63 5.37 24 12 24C18.63 24 24 18.63 24 12C24 5.37 18.63 0 12 0Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5261_10731"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrequencyWhiteIcon);
export default __webpack_public_path__ + "static/media/frequencyWhiteIcon.87c3cc199ca8b1530a458e1617a18778.svg";
export { ForwardRef as ReactComponent };